import React from "react";
import { Link } from "react-router-dom";
import PermissionConst from "../permission-const";
import { TPermission } from "../helpers/permission-types-helper";
import { Localize } from "components/service";

interface IPermissionInfoFieldProps {
    permission: TPermission;
}

const PermissionInfoField: React.FC<IPermissionInfoFieldProps> = ({ permission }) => {
    return Object.keys(permission).length ? (
        <Link
            className="table-link-underline"
            to={`${PermissionConst.basePath}/${permission?.id}/`}
        >
            <strong>
                <Localize>{permission.slug}</Localize>
            </strong>
        </Link>
    ) : (
        <strong>&mdash;</strong>
    );
};

export default PermissionInfoField;